import { render } from "./Menu.vue?vue&type=template&id=40191a04&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=40191a04&scoped=true&lang=css"

import exportComponent from "D:\\vue\\rs459\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40191a04"]])

export default __exports__